<template>
	<div>
		<van-field v-if="!disabled && !readonly" :required="formCreateInject.rule.validate[0].required"
			input-align="right" :label="formCreateInject.prop.title.title">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
			<template #input>
				<van-stepper :value="number" :min="config.min" :max="config.max" :step="step" :decimal-length="precision"
					theme="round" button-size="22" input-width="100px" @change="change" />
			</template>
		</van-field>
		<van-field v-else readonly :required="formCreateInject.rule.validate[0].required" input-align="right"
			:label="formCreateInject.prop.title.title" :value="value" >
		</van-field>
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				number: isNaN(parseFloat(this.value)) ? null : parseFloat(this.value),
				config: {
					min: this.min,
					max: this.max,
					disabled: this.disabled,
					readonly: this.readonly,
				}
			}
		},
		created() {


		},
		mounted() {

		},
		watch: {
			value(e) {
				if (e === null) {
					this.config.min = this.min
					this.config.max = this.max
				}
				this.number = e
			}
			// value(e) {
			// 	this.change(e)
			// }
		},
		computed: {
			// suffix() {
			// 	if (this.readonly) {
			// 		return 'vxe-icon-eye-fill'
			// 	}
			// 	if (this.disabled) {
			// 		return 'vxe-icon-lock-fill'
			// 	}
			// 	return 'vxe-icon-edit'
			// }
		},
		methods: {
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
				this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
			},

		},

	}
</script>
<style scope>

</style>
